import { QueryParams } from '../../commonMixed';

export class GetMaintenanceItemsByOrganizationIdRequest extends QueryParams {}
export class GetAlertTypesRequest extends QueryParams {}
